import { provinceI18n } from "@/service/i18n/translations/province";
import { specializationsI18n } from "@/service/i18n/translations/specializations";
import { shopI18n } from "./translations/shop";
import { commonI18n } from "./translations/common";

export const plTranslations = {
  ...provinceI18n,
  ...specializationsI18n,
  ...shopI18n,
  ...commonI18n,
};
